import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GeometryResponse } from '@fleet-beat/api';

import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyDto,
  PageableListDto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/places/route`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  findRoute(body: { from: string; to: string }, auth: AuthHeaders): Observable<ResponseDto<GeometryResponse>> {
    return this.baseApiService.post(`${this.baseUrl}`, { ...body }, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<GeometryResponse>) => this.baseApiService.mapResponseV2(response)),
    );
  }
}
